import { useMemo } from 'react';

const copiesByReleaseType = {
  draw: {
    dialogCta: {
      normal: 'subscriptionCta.draw.learnMoreDialog.buttonTitle',
      mobile: 'subscriptionCta.draw.learnMoreDialog.buttonTitle',
      success: 'subscriptionCta.draw.buttonSuccessTitle',
    },
    stickyCta: {
      normal: 'subscriptionCta.draw.stickyHeader.buttonTitle',
      mobile: 'subscriptionCta.draw.stickyHeader.buttonTitle',
      success: 'subscriptionCta.draw.stickyHeader.buttonSuccessTitle',
    },
  },
  auction: {
    dialogCta: {
      normal: 'subscriptionCta.auction.buttonTitle',
      mobile: 'subscriptionCta.auction.buttonTitle',
      success: 'subscriptionCta.auction.buttonSuccessTitle',
    },
    stickyCta: {
      normal: 'subscriptionCta.auction.stickyHeader.buttonTitle',
      mobile: 'subscriptionCta.auction.stickyHeader.buttonTitle',
      success: 'subscriptionCta.auction.stickyHeader.buttonSuccessTitle',
    },
  },
  preOrder: {
    dialogCta: {
      normal: 'subscriptionCta.preOrder.learnMoreDialog.buttonTitle',
      mobile: 'subscriptionCta.preOrder.learnMoreDialog.buttonTitle',
      success: 'subscriptionCta.preOrder.buttonSuccessTitle',
    },
    stickyCta: {
      normal: 'subscriptionCta.preOrder.stickyHeader.buttonTitle',
      mobile: 'subscriptionCta.preOrder.stickyHeader.buttonTitle',
      success: 'subscriptionCta.preOrder.stickyHeader.buttonSuccessTitle',
    },
  },
};

export const useDrawButtonLabels = (
  buttonLocation: string,
  isPreOrder: boolean,
  isMobile = false,
  isAuction = false,
) => {
  const copies = useMemo(() => {
    let selectedCopies = copiesByReleaseType.draw;
    if (isPreOrder) {
      selectedCopies = copiesByReleaseType.preOrder;
    }

    if (isAuction) {
      selectedCopies = copiesByReleaseType.auction;
    }

    return buttonLocation === 'dialogCta'
      ? selectedCopies.dialogCta
      : selectedCopies.stickyCta;
  }, [buttonLocation, isPreOrder, isAuction]);

  return {
    normal: isMobile ? copies.mobile : copies.normal,
    success: copies.success,
  };
};
